import { cn } from '@/lib/utils'
import * as React from 'react'
import { Label } from './label'
import type { FAIconProps } from '../fa-icon'
import { FAIcon } from '../fa-icon'

export type InputProps = Omit<React.ComponentProps<'input'>, 'onChange'> & {
  label?: string
  error?: string | null
  iconRight?: FAIconProps

  onChange?: (value: string, evt: React.ChangeEvent<HTMLInputElement>) => void
}

function Input({
  className,
  type,

  label,
  error,
  iconRight,

  onChange,

  ...props
}: InputProps) {
  function handleChange(evt: React.ChangeEvent<HTMLInputElement>) {
    if (!onChange) return
    onChange(evt.target.value, evt)
  }

  return (
    <div className="relative">
      {!!label && (
        <Label className="ml-1 mb-1" htmlFor={props.id}>
          {label}
        </Label>
      )}

      <input
        type={type}
        data-slot="input"
        className={cn(
          'min-w-0 w-full',
          'bg-white border border-gray-200 rounded-xl text-neutral-700 text-lg p-4 transition-[border]',
          'focus-visible:border-secondary focus-visible:outline-none',
          'disabled:pointer-events-none disabled:text-neutral-400',
          !!error && 'border-red-700 rounded-b-none',
          !!iconRight && 'pr-13',
          className
        )}
        {...props}
        onChange={handleChange}
      />

      {!!error && (
        <div className="absolute left-0 right-0 py-px px-4 rounded-b-xl bg-red-700 text-white text-xs">
          {error}
        </div>
      )}

      {!!iconRight && (
        <div className="absolute top-1/2 right-4 translate-y-[calc(-50%+1px)] text-xl">
          <FAIcon fixedWidth {...iconRight} />
        </div>
      )}
    </div>
  )
}

function InputWithChangeEvent({
  onChange,
  ...props
}: Omit<InputProps, 'onChange'> & {
  onChange?: React.ChangeEventHandler<HTMLInputElement>
}) {
  function handleChange(_: string, evt: React.ChangeEvent<HTMLInputElement>) {
    onChange?.(evt)
  }

  return <Input {...props} onChange={handleChange} />
}

export { Input, InputWithChangeEvent }
